import { motion } from "framer-motion";

const EVENTS = [
  "Pebble Beach Concours d'Elegance",
  "AT&T Pebble Beach Pro-Am",
  "Monterey Car Week",
  "The Quail Motorsports Gathering",
  "Pebble Beach Food & Wine",
];

export default function SeasonStrip() {
  return (
    <section
      data-testid="season-strip"
      className="border-y border-line bg-abyss py-14 sm:py-16"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8 }}
          className="font-mono text-[11px] uppercase tracking-[0.35em] text-champagne"
        >
          Where We&apos;ll See You This Season
        </motion.p>
        <div className="mt-8 flex flex-wrap gap-x-12 gap-y-6">
          {EVENTS.map((event, i) => (
            <motion.div
              key={event}
              data-testid={`season-event-${i + 1}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="flex items-baseline gap-3"
            >
              <span className="font-mono text-[10px] tracking-[0.2em] text-champagne/70">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="font-serif text-xl tracking-tight text-bone/90 sm:text-2xl">
                {event}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
